import { AdminUserPermissionsEnum } from '@/lib/enum';
import userStore from '@/store/userStore';
import { useShallow } from 'zustand/react/shallow';

const useUserConnected = () => {

  const { userConnected, setUserConnected } = userStore(
    useShallow(l => ({ userConnected: l.user, setUserConnected: l.setStoreUser }))
  );

  const hasPermissions = (...permissions: AdminUserPermissionsEnum[]) =>
    userConnected?.root ||
    userConnected?.permissions?.some(l => permissions.includes(l));

  return ({
    setUserConnected,
    hasPermissions,
    userConnected
  });

};

export default useUserConnected;
